/*
 * SessionStorage clearing on finding different page
 */
var previousPageURL = sessionStorage.getItem('url'),
CurrentPageURL = document.URL,
previousFormStep = sessionStorage.getItem('formstep'),
currentFormStep = $("#Stage").val();

//two conditions when actually URL is changed or URL is same but form step is changed
if ((previousPageURL != null &&
    previousPageURL != CurrentPageURL) ||
    (previousFormStep != null &&
    previousFormStep != currentFormStep)) {
    sessionStorage.clear();
}
sessionStorage.setItem('url', CurrentPageURL);
sessionStorage.setItem('formstep', currentFormStep);

/*
 * Select dropdown default option selection on page reload
 */
var selectGroup = $("select");

selectGroup.on("change", function () {
    var _self = $(this)
    , selectName = _self.attr("name")
   , optionIndex = this.selectedIndex;

    _self.find("option[selected]").
   prop('selected', false);

    sessionStorage.setItem('select-' + selectName + '-index', optionIndex);
});
selectGroup.each(function () {
    var optionIndex = sessionStorage.getItem('select-' + $(this).attr("name") + '-index');
    if (optionIndex != null)
        $(this.item(optionIndex))
            .attr("selected", "true");
});


/*
 * Select last tab selection on page reload
 */
var tabsGroup = $("[data-id='jquery-tabs']");
tabsGroup.tabs({
    activate: function (e, ui) {
        var currentSelectionIndex = ui.newTab.index().toString(),
        tabIndexInTabsGroup = tabsGroup.index(this);
        sessionStorage.setItem('tab-' + tabIndexInTabsGroup + '-index', currentSelectionIndex);
    }
});
tabsGroup.each(function (i, ele) {
    var tabIndex = sessionStorage.getItem('tab-' + i + '-index');
    if (tabIndex != null)
        $(this).tabs("option", "active", tabIndex);
});
